import React, { useEffect, useMemo, useState } from "react";
import config, { getConfig } from "../../../../../network/auth";
import axios from "../../../../../network/api";
import { baseUrl } from "../../../../../network/constants/constants";
import { Button, Spinner } from "react-bootstrap";
import './blog-screen.css';
import BlogForm from "../blog-component/blog-form";
import BlogTable from "../blog-component/blog-component";
import './blog-screen.css'


export const BlogScreen = () => {
    const [blogs, setBlogs] = useState([]);
    const [loading, setLoading] = useState(false);
    const [showModal, setShowModal] = useState(false);
    const [selectedBlog, setSelectedBlog] = useState(null);

    const config = useMemo(() => {
        return getConfig();
    }, []);

    // Get blogs
    const fetchBlogs = () => {
        setLoading(true);
        axios
            .get(baseUrl + `web/blog-list/`, config)
            .then((response) => {
                setBlogs(response.data.results);
                setLoading(false);
            })
            .catch((error) => {
                console.error("Blogs Error:", error);
                setLoading(false);
            });
    };

    useEffect(() => {
        fetchBlogs();
    }, []);

    const handleShowModal = (blog = null) => {
        setSelectedBlog(blog);
        setShowModal(true);
    };

    const handleCloseModal = () => {
        setShowModal(false);
        setSelectedBlog(null);
    };

    const handleFormSubmit = (formData) => {
        const url = selectedBlog
            ? `${baseUrl}web/blog-edit-delete/${selectedBlog.id}/`
            : `${baseUrl}web/blog-create/`;
        const method = selectedBlog ? "patch" : "post";

        const form = new FormData();

        if (selectedBlog) {
            form.append("id", selectedBlog.id);
        }
        form.append("blog_title", formData.blog_title);
        form.append("blog_body", formData.blog_body);
        form.append("blog_author", formData.blog_author);
        form.append("blog_date", formData.blog_date);

        if (formData.blog_author_image && formData.blog_author_image instanceof File) {
            form.append("blog_author_image", formData.blog_author_image);
        }

        // Blog Image
        if (formData.blog_image && formData.blog_image instanceof File) {
            form.append("blog_image", formData.blog_image);
        }

        // Create a new config object without Content-Type 
        // Let browser set it automatically with correct boundary for multipart/form-data
        const uploadConfig = { ...config };
        if (uploadConfig.headers) {
            delete uploadConfig.headers['Content-Type'];
        }

        axios({
            method,
            url,
            data: form,
            headers: uploadConfig.headers,
        })
            .then((response) => {
                console.log("Blog saved successfully:", response.data);
                fetchBlogs();
                handleCloseModal();
            })
            .catch((error) => {
                console.error("Error saving blog:", error);
                if (error.response) {
                    console.error("Error details:", error.response.data);
                    console.error("Error status:", error.response.status);
                }
            });
    };
    
    const deleteBlog = (blogId) => {
        if (window.confirm("Are you sure you want to delete this blog?")) {
            setLoading(true);

            axios
                .delete(`${baseUrl}web/blog-edit-delete/${blogId}/`, config)
                .then((response) => {
                    console.log("Blog deleted successfully");
                    fetchBlogs();
                    setLoading(false);
                })
                .catch((error) => {
                    console.error("Error deleting blog:", error);
                    setLoading(false);
                });
        }
    };

    return (
        <div className="blog-container">
            <button className="btn-add" onClick={() => handleShowModal()}>
                + Add Blog
            </button>
            
            {loading ? (
                <div className="loader-container">
                    <Spinner className='spinner-loader' />
                </div>
            ) : (
                <div className="blog-grid">
                    <BlogTable
                        blogs={blogs}
                        loading={loading} 
                        onEdit={handleShowModal}
                        onDelete={deleteBlog}
                    />
                </div>
            )}
            
            <BlogForm
                show={showModal}
                handleClose={handleCloseModal}
                handleSubmit={handleFormSubmit}
                blog={selectedBlog}
            />
        </div>
    );
};

export default BlogScreen;